"use client";

import { useRef, type RefObject } from "react";
import dynamic from "next/dynamic";
import ScrollReveal from "./ScrollReveal";
import { useAfterPaint } from "@/lib/motion/useAfterPaint";

const StatsCountUp = dynamic(() => import("./StatsCountUp"), { ssr: false });

const STATS = [
  { value: "92.7%", label: "of requests", sub: "run on Capuchin" },
  { value: "50+", label: "agent tools", sub: "implemented" },
  { value: "4", label: "execution", sub: "environments" },
  { value: "100+", label: "messages per", sub: "session" },
];

function Motion({ scope }: { scope: RefObject<HTMLDivElement | null> }) {
  return useAfterPaint(1) ? <StatsCountUp scope={scope} /> : null;
}

export default function ProofBand() {
  const gridRef = useRef<HTMLDivElement>(null);

  return (
    <section className="py-12 lg:py-16">
      <div className="max-w-5xl mx-auto px-6">
        <ScrollReveal>
          <div ref={gridRef} className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
            {STATS.map((stat) => (
              <div key={stat.label} className="text-center">
                <div
                  data-count={stat.value}
                  className="text-[clamp(2rem,5vw,3rem)] font-black tracking-tight leading-none mb-1 tabular-nums hero-gradient-text"
                >
                  {stat.value}
                </div>
                <div className="text-[12px] font-medium uppercase tracking-wider text-(--text-muted)">
                  {stat.label}
                </div>
                <div className="text-[12px] text-(--text-secondary)">
                  {stat.sub}
                </div>
              </div>
            ))}
          </div>
          <p className="text-center text-[11px] text-(--text-muted) mt-6 italic">
            Measured on production traffic. Not projections.
          </p>
        </ScrollReveal>
        <Motion scope={gridRef} />
      </div>
    </section>
  );
}
